export default (url: string) => {
    new Image().src = url
}
